import React, { useEffect, useState } from "react";
import { useI18n } from "../context/I18nContext";
import { api } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter, DialogTrigger } from "./ui/dialog";
import { LinkSimple } from "@phosphor-icons/react";
import { toast } from "sonner";

export const LinkClientButton = ({ base, account, onDone }) => {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const [clients, setClients] = useState([]);
  const [uid, setUid] = useState(account.user_id || "");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) {
      setUid(account.user_id || "");
      api.get("/admin/clients").then((r) => setClients(r.data.map((c) => c.user))).catch(() => {});
    }
  }, [open]); // eslint-disable-line

  const save = async () => {
    setBusy(true);
    try {
      await api.put(`${base}/${account.id}/link`, { user_id: uid || null });
      toast.success(t("saved"));
      setOpen(false);
      onDone && onDone();
    } catch (e) { toast.error(e.response?.data?.detail || "Error"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button data-testid={`link-account-${account.id}`} title={t("link_member")} aria-label={t("link_member")} size="sm" variant="outline"
          className={account.user_id ? "border-emerald-400 text-emerald-700 hover:bg-emerald-50" : "border-amber-300 text-amber-700 hover:bg-amber-50"}>
          <LinkSimple size={15} weight="bold" />
        </Button>
      </DialogTrigger>
      <DialogContent data-testid="link-account-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display text-emerald-900">{t("link_member")}</DialogTitle>
          <DialogDescription>{account.account_number} · {account.full_name}</DialogDescription>
        </DialogHeader>
        <div>
          <Label>{t("member")}</Label>
          <select data-testid="link-account-select" value={uid} onChange={(e) => setUid(e.target.value)}
            className="mt-1.5 w-full h-11 rounded-md border border-gray-200 px-2 text-sm text-emerald-900 bg-white">
            <option value="">{t("none_option")}</option>
            {clients.map((c) => <option key={c.id} value={c.id}>{c.name}{c.email ? ` · ${c.email}` : c.phone ? ` · ${c.phone}` : ""}</option>)}
          </select>
          <p className="text-xs text-slate-400 mt-2">{t("link_member_hint")}</p>
        </div>
        <DialogFooter>
          <Button data-testid="link-account-save" onClick={save} disabled={busy} className="bg-emerald-800 hover:bg-emerald-900">{busy ? t("loading") : t("save")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
